const useDialogSetModals = ({
  currentUser,
  suggestionUsage,
  setIsSignUpModalOpen,
  setIsEmailConfirmationModalOpen,
  setSubscriptionModalState,
}) => {
  const setModals = (eventType = '') => {

    if (!currentUser) {
      setIsSignUpModalOpen(true);
      return true;
    } else if (!currentUser?.emailVerified) {
      setIsEmailConfirmationModalOpen(true);
      return true;
    } else if (!currentUser?.hasSubscription) {
      if (eventType === 'suggestions_button_click' && suggestionUsage < 2) {
        return false;
      }

      setSubscriptionModalState({
        isOpen: true,
        renderedForReason: eventType,
      });
      return true;
    }
    return false;
  };

  return setModals;
};

export default useDialogSetModals;
